import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GetTraceabilityByWrNumber,
  GetTraceabilityFilters,
} from '../../helpers/traceabilities_helper';
import {
  getFilterListFailWrNumber,
  getFilterListSuccessWrNumber,
  getTraceabilityError,
  getTraceabilityFiltersSuccess,
  getTraceabilitySuccess,
} from './actions';
import { traceabilitiesTypes } from './actionTypes';

function* getTraceabilitySaga(WRNUMBER: any) {
  const filters = {
    dynamicFilter: `, WRNUMBER: "${WRNUMBER.payload.WRNUMBER}"`,
  };
  const payload = { filters };
  try {
    const response: Promise<any> = yield call(GetTraceabilityByWrNumber, {
      payload,
    });
    if (response !== null || response !== undefined) {
      yield put(getFilterListSuccessWrNumber(response));
    }
  } catch (error) {
    yield put(getFilterListFailWrNumber(error));
  }
}
function* getTraceabilitiesSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(
      GetTraceabilityByWrNumber,
      payload,
    );
    if (response) {
      yield put(getTraceabilitySuccess(response));
    }
  } catch (error) {
    yield put(getTraceabilityError(error));
  }
}
function* getTraceabilitiesFiltersSaga(payload: any) {
  try {
    const response: Promise<any> = yield call(GetTraceabilityFilters, payload);
    if (response) {
      yield put(getTraceabilityFiltersSuccess(response));
    }
  } catch (error) {
    yield put(getTraceabilityError(error));
  }
}

function* traceabilitiesSaga() {
  yield takeLatest(
    traceabilitiesTypes.GET_FILTER_LIST_WRNUMBER,
    getTraceabilitySaga,
  );
  yield takeLatest(traceabilitiesTypes.GET_FILTER_LIST, getTraceabilitiesSaga);
  yield takeLatest(
    traceabilitiesTypes.GET_FILTERS,
    getTraceabilitiesFiltersSaga,
  );
}

export default traceabilitiesSaga;
